import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const menuItems = [
  { label: 'दैनिक नोंदणी',   icon: '📋', to: '/dashboard' },
  { label: 'दैनिक रजिस्टर',  icon: '📅', to: '/DailyRegister' },
  { label: 'विश्लेषण',       icon: '📊', to: '/Analytics' },
  { label: 'डिव्हिडंड',        icon: '🎁', to: '/Bonus' },
  { label: 'पेमेंट रजिस्टर', icon: '💰', to: '/payment' },
  { label: 'डेअरी रजिस्टर',  icon: '🏪', to: '/DairyRegister' },
  { label: 'डेअरी विक्री',    icon: '🛒', to: '/DairySales' },
  { label: 'इतर खर्च',        icon: '🧾', to: '/DairyExpense' },
  { label: 'कस्टम रेट चार्ट', icon: '🎯', to: '/CustomRateChart' },
  { label: 'सभासद नोंदणी',   icon: '➕', to: '/AddMember' },
  { label: 'पासवर्ड बदला',   icon: '🔒', to: '/ChangePassword' },
];

const Nav = () => {
  const [open, setOpen] = useState(false);
  const dairyName = localStorage.getItem("dairy_name");

  // Prevent body scroll when drawer is open
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <>
      <nav className="nav">
        <h1>🐄 {dairyName}</h1>
        <button className="admin-menu-btn" onClick={() => setOpen(o => !o)} aria-label="Menu">
          <i className={`fa-solid fa-${open ? 'xmark' : 'bars'}`}></i>
        </button>
      </nav>

      {/* Backdrop */}
      {open && <div className="drawer-backdrop" onClick={() => setOpen(false)} />}

      {/* Slide-in drawer from right */}
      <div className={`admin-drawer ${open ? 'admin-drawer--open' : ''}`}>
        <div className="admin-drawer-header">
          <span className="admin-drawer-title">🐄 {dairyName}</span>
          <button className="admin-drawer-close" onClick={() => setOpen(false)}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div className="admin-drawer-items">
          {menuItems.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              className="admin-drawer-item"
              onClick={() => setOpen(false)}
            >
              <span className="admin-drawer-icon">{item.icon}</span>
              <span className="admin-drawer-label">{item.label}</span>
              <i className="fa-solid fa-chevron-right admin-drawer-arrow"></i>
            </Link>
          ))}
        </div>

        <div className="admin-drawer-footer">
          <Link
            to="/Logout"
            className="admin-drawer-item admin-drawer-logout"
            onClick={() => setOpen(false)}
          >
            <span className="admin-drawer-icon">🚪</span>
            <span className="admin-drawer-label">लॉग आउट</span>
            <i className="fa-solid fa-chevron-right admin-drawer-arrow"></i>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Nav;
